import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchMedics = async ({
  page = 1,
  limit = 10,
  filter = null,
  search = null,
  status = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    // Object.entries(filter).forEach(([key, value]) => {
    //   if (!value || value === 'all') return;

    //   if (Array.isArray(value)) {
    //     query += `&${key}=${value.map((v) => encodeURIComponent(v)).join(',')}`;
    //   } else {
    //     query += `&${key}=${encodeURIComponent(value)}`;
    //   }
    // });

    if (search) {
      query += `&search=${search}`;
    }

    if (status) {
      query += `&status=${status}`;
    }

    const response = await authClient.get(`/doctors${query}`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const deleteMedic = async (id) => {
  try {
    const response = await authClient.delete(`/users/${id}/delete`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const activateMedic = async (id) => {
  try {
    const response = await authClient.patch(`/doctors/${id}/activate`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri aktivaciji mentora.'
    );
    return { data: null, success: false, message: message };
  }
};

export const createMedic = async (payload) => {
  try {
    const response = await authClient.post(`/doctors`, payload);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

// Existing plain users (role client, status ACTIVE) that can be promoted to mentor.
// Backend-scoped: this is the only user list a clinic_owner is allowed to read.
export const fetchPromotableUsers = async ({
  page = 1,
  limit = 20,
  search = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    if (search) {
      query += `&search=${encodeURIComponent(search)}`;
    }

    const response = await authClient.get(`/doctors/promotable-users${query}`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

// Promotes an existing user to mentor instead of creating a second account for them.
// Sends `userId`, the (possibly edited) `referralCode` and optionally `clinic` — the
// backend keeps their password and referredByDoctor upline as they already are.
export const promoteUserToMedic = async (payload) => {
  try {
    const response = await authClient.post(`/doctors/promote`, payload);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri postavljanju korisnika za mentora.'
    );
    return { data: null, success: false, message: message };
  }
};

// A doctor creating their own referred mentor (self-service) — backend derives
// clinic/referredByDoctor from the authenticated doctor, so the payload here is
// just the mentor's own account fields.
export const createReferredDoctor = async (payload) => {
  try {
    const response = await authClient.post(`/doctors/mentors`, payload);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const fetchMedic = async (id) => {
  try {
    const response = await authClient.get(`/users/${id}`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

// Unlike fetchMedic (/users/:id), this one is open to clinic owners for their own
// clinic's mentors, and returns the clinic populated with its name.
export const fetchDoctor = async (id) => {
  try {
    const response = await authClient.get(`/doctors/${id}`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju mentora.'
    );
    return { data: null, success: false, message: message };
  }
};

export const fetchSingleDoctorSummary = async (id) => {
  try {
    const response = await authClient.get(`/doctors/${id}/summary`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const fetchSingleDoctorOrders = async ({ id, page, limit }) => {
  try {
    let query = `?page=${page}&limit=${limit}`;
    const response = await authClient.get(`/doctors/${id}/orders${query}`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getMedicOrders = async (id, params) => {
  try {
    const response = await authClient.get(`/doctors/${id}/orders`, {
      params,
    });

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const exportMedicOrders = async (id, params) => {
  try {
    const response = await authClient.get(`/doctors/${id}/orders/export`, {
      params: params,
      responseType: 'blob',
    });

    return { success: true, data: response.data, message: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getDoctorSummary = async (id) => {
  try {
    const response = await authClient.get(`/doctors/${id}/summary`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getDoctorReferralLink = async (id) => {
  try {
    const response = await authClient.get(`/doctors/${id}/referral`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getDoctorReferralChain = async (id) => {
  try {
    const response = await authClient.get(`/doctors/${id}/referral-chain`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju referral lanca.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getDoctorCharityLedger = async (
  id,
  { month, page = 1, limit = 20 } = {}
) => {
  try {
    let query = `?page=${page}&limit=${limit}`;
    if (month) query += `&month=${month}`;
    const response = await authClient.get(
      `/doctors/${id}/charity-ledger${query}`
    );

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju humanitarnih donacija.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getDoctorCharityLedgerSummary = async (id) => {
  try {
    const response = await authClient.get(
      `/doctors/${id}/charity-ledger/summary`
    );

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju pregleda donacija.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getDoctorDirectReferrals = async (id, params) => {
  try {
    const response = await authClient.get(`/doctors/${id}/direct-referrals`, {
      params,
    });

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju liste mentora.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getDoctorLinkedAgents = async (id, params) => {
  try {
    const response = await authClient.get(`/doctors/${id}/agents`, {
      params,
    });

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju liste agenata.'
    );
    return { data: null, success: false, message: message };
  }
};

export const updateDoctorReferralChainEntry = async (
  id,
  entryDoctorId,
  percent
) => {
  try {
    const response = await authClient.patch(
      `/doctors/${id}/referral-chain/${entryDoctorId}`,
      { percent }
    );

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izmeni procenta u referral lancu.'
    );
    return { data: null, success: false, message: message };
  }
};

export const markDoctorPayoutEntryStatus = async (
  doctorId,
  entryId,
  status
) => {
  try {
    const response = await authClient.patch(
      `/doctors/${doctorId}/commission-ledger/${entryId}/status`,
      { status }
    );

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izmeni statusa provizije.'
    );
    return { data: null, success: false, message: message };
  }
};

export const markDoctorPayoutEntriesBulk = async (
  doctorId,
  entryIds,
  status
) => {
  try {
    const response = await authClient.patch(
      `/doctors/${doctorId}/commission-ledger/bulk-status`,
      { entryIds, status }
    );

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izmeni statusa provizije.'
    );
    return { data: null, success: false, message: message };
  }
};

// Clinics
export const fetchAllClinics = async () => {
  try {
    const response = await authClient.get(`/clinics/names`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const fetchClinics = async ({
  page = 1,
  limit = 10,
  filter = null,
  search = null,
  isActive = null,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    Object.entries(filter).forEach(([key, value]) => {
      if (!value || value === 'all') return;

      if (Array.isArray(value)) {
        query += `&${key}=${value.map((v) => encodeURIComponent(v)).join(',')}`;
      } else {
        query += `&${key}=${encodeURIComponent(value)}`;
      }
    });

    if (search) {
      query += `&searchTerm=${search}`;
    }

    if (isActive !== null) {
      query += `&isActive=${isActive}`;
    }

    const response = await authClient.get(`/clinics${query}`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const createClinic = async (payload) => {
  try {
    const response = await authClient.post(`/clinics`, payload);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const fetchSingleClinic = async (id) => {
  try {
    const response = await authClient.get(`/clinics/${id}`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const deleteClinic = async (id) => {
  try {
    const response = await authClient.delete(`/clinics/${id}/delete`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getClinicMedics = async (id, params) => {
  try {
    const response = await authClient.get(`/clinics/${id}/doctors`, {
      params: params,
    });

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getClinicSummary = async (id) => {
  try {
    const response = await authClient.get(`/clinics/${id}/summary`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

export const getClinicReferralLink = async (id) => {
  try {
    const response = await authClient.get(`/clinics/${id}/referral`);

    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju korisnika.'
    );
    return { data: null, success: false, message: message };
  }
};

// Clinic referral-commission awarding disabled (2026-08-17): the backend endpoints
// these called (/clinics/:id/orders, /clinics/:id/commission-ledger/*) are commented
// out — clinics no longer earn or get paid a commission cut.
// export const getClinicOrders = async (id, params) => {
//   try {
//     const response = await authClient.get(`/clinics/${id}/orders`, {
//       params,
//     });
//
//     return response.data;
//   } catch (error) {
//     const message = extractErrorMessage(
//       error,
//       'Došlo je do greške pri dobavljanju porudžbina.'
//     );
//     return { data: null, success: false, message: message };
//   }
// };
//
// export const markClinicPayoutEntryStatus = async (
//   clinicId,
//   entryId,
//   status
// ) => {
//   try {
//     const response = await authClient.patch(
//       `/clinics/${clinicId}/commission-ledger/${entryId}/status`,
//       { status }
//     );
//
//     return response.data;
//   } catch (error) {
//     const message = extractErrorMessage(
//       error,
//       'Došlo je do greške pri izmeni statusa provizije.'
//     );
//     return { data: null, success: false, message: message };
//   }
// };
//
// export const markClinicPayoutEntriesBulk = async (
//   clinicId,
//   entryIds,
//   status
// ) => {
//   try {
//     const response = await authClient.patch(
//       `/clinics/${clinicId}/commission-ledger/bulk-status`,
//       { entryIds, status }
//     );
//
//     return response.data;
//   } catch (error) {
//     const message = extractErrorMessage(
//       error,
//       'Došlo je do greške pri izmeni statusa provizije.'
//     );
//     return { data: null, success: false, message: message };
//   }
// };

export const exportClinics = async ({ search = null, status = null }) => {
  try {
    const params = new URLSearchParams();

    if (search) params.append('search', search);
    if (status) params.append('status', status);

    const query = params.toString() ? `?${params.toString()}` : '';

    const response = await authClient.get(`/clinics/export${query}`, {
      responseType: 'blob',
    });

    if (response.headers['content-type']?.includes('application/json')) {
      const text = await response.data.text();
      const jsonData = JSON.parse(text);
      return {
        data: null,
        success: jsonData.success,
        message: jsonData.message,
      };
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `organizacije-${status ?? 'svi'}-${new Date().toISOString().split('T')[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return {
      data: true,
      success: true,
      message: 'Organizacije uspešno izvezene',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izvozu organizacija.'
    );
    return { data: null, success: false, message: message };
  }
};
